<template>

    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex md12 pt-0>
                <v-data-table
                        :headers="HEADERS_TERMS.slice(0,HEADERS_TERMS.length)"
                        :items="items"
                        :pagination.sync="pagination"
                        item-key="id"
                        class="dataTable"
                >

                    <template slot="headers" slot-scope="props">
                        <tr>
                            <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)"
                            >
                                {{ header.text }}
                            </th>
                        </tr>
                    </template>
                    <template slot="items" slot-scope="props">
                        <tr style="cursor: pointer">
                            <td class="text-xs-center" width="5%"  @click="selectRow(props.item)">{{ props.item.id }}</td>
                            <td class="text-xs-left"  @click="selectRow (props.item)">{{ props.item.title }}</td>
                            <td class="text-xs-center" width="12%" @click="selectRow (props.item)">{{ props.item.created_at |time}}</td>
                            <td class="text-xs-center" width="12%" @click="selectRow (props.item)">{{ props.item.updated_at |time}}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	import MyMixinList from '../../mixins/MyMixinList'
	import MyMixinCommon from '../../mixins/MyMixinCommon';
	import { mapActions, mapGetters } from 'vuex'
    import * as termsApi from "../../service/api/terms-api";

	export default {
		mixins: [ MyMixinCommon, MyMixinList ],
		components: {

		},

		data: () => ({

            items: [],

		}),
		created() {
            // 권한체크
            this.permissionCheck()
		},

		computed: {

		},
		methods: {
			...mapGetters( 'user', [ 'getUserId','getLoginType' ] ),

			/////////////////////////////////////////////////// INIT /////////////////////////////////////////////////////////

            permissionCheck(){
                if(Number(this.getLoginType())  >= 3) {

                    this.reqList()

                }else{

                    this.$dialog.alert('관리자 권한이 없어 메인페이지로 이동합니다.').then(dialog=>{
                        this.$router.push( 'contents' )
                    })

                }

            },

            init() {
                this.permissionCheck()
            },

			/////////////////////////////////////////////////// FUNC /////////////////////////////////////////////////////////

            showUseTerms() {
                this.$router.replace( { name: 'terms-use' } );
            },

            showPrivacyTerms() {
                this.$router.replace( { name: 'terms-privacy' } );
            },

            reqList() {

                return termsApi.retrieveTerms().then(res => {
                    console.log(res)
                    this.items = res.data
                }).catch(e=>{
                    this.$dialog.alert(e.message)
                })
            },

            selectRow( item ) {
                switch (item.term_type) {
			        case 'use':
                        this.$router.replace( { name: 'terms-use' } );
                        break;
                    case 'privacy':
                        this.$router.replace( { name: 'terms-privacy' } );
                        break;
                    default: break;
                }
            },
		},
	}

</script>
<style>
    .terms-title {margin: 0 !important;}
</style>
